new Swiper('.block__case-carrousel .swiper-container', {
  grabCursor: true,
  spaceBetween: 0,
  slidesPerView: 1.5,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    575: {
      slidesPerView: 1.75,
    },
    700: {
      slidesPerView: 2,
    },
    940: {
      slidesPerView: 2.75,
    },
    1200: {
      slidesPerView: 3.5,
    },
    1500: {
      slidesPerView: 4.5,
    },
    1800: {
      slidesPerView: 4.5,
    },
  }
});